import { Injectable } from "@angular/core";
import { IRemoteOrderModeSelector } from "./remoteOrderModeSelector.facade";
import { BehaviorSubject, Observable } from "rxjs";
import Utils from "../../shared/utils";
import { CoreLogService } from "../../services/log.service";
import { WebShopService } from "../../services/webShop.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";

class RemoteOrderModeSelector implements IRemoteOrderModeSelector {
  // TODO portal data required
  private _model: any;

  constructor(model: any) {
    this._model = model;
  }

  public get title(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.title_en) ? this._model.title_de : this._model.title_en;
  }

  public get description(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.description_en) ? this._model.description_de : this._model.description_en;
  }

  public get image(): string {
    return this._model.image;
  }

  public get hasImage(): boolean {
    return this._model.hasImage;
  }

  public get onePersonOrder_title(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.onePersonOrder_title_en) ? this._model.onePersonOrder_title_de : this._model.onePersonOrder_title_en;
  }

  public get onePersonOrder_description(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.onePersonOrder_description_en) ? this._model.onePersonOrder_description_de : this._model.onePersonOrder_description_en;
  }

  public get groupOrder_title(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.groupOrder_title_en) ? this._model.groupOrder_title_de : this._model.groupOrder_title_en;
  }

  public get groupOrder_description(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.groupOrder_description_en) ? this._model.groupOrder_description_de : this._model.groupOrder_description_en;
  }
}

@Injectable()
export class RemoteOrderModeSelectorService {
  private _remoteOrderModeSelector: RemoteOrderModeSelector = null;
  private _remoteOrderModeSelector_subject: BehaviorSubject<IRemoteOrderModeSelector> = new BehaviorSubject<IRemoteOrderModeSelector>(null);

  constructor(
    private _coreLogService: CoreLogService,
    private _webShopService: WebShopService,
  ) { }

  public get remoteOrderModeSelector$(): Observable<IRemoteOrderModeSelector> {
    return this._remoteOrderModeSelector_subject.asObservable();
  }

  public async loadData() {
    const model = await this._webShopService.getPreOrderSelectionSettings();
    if (model) {
      if (!Utils.IsEqual(this._remoteOrderModeSelector, model)) {
        this._remoteOrderModeSelector = new RemoteOrderModeSelector(model);
        this._remoteOrderModeSelector_subject.next(this._remoteOrderModeSelector);
      }
    } else {
      this._coreLogService.error("RemoteOrderModeSelectorService.loadData", "load fail");
    }
  }
}
